import { Component, OnInit } from '@angular/core';
import { InventarioService } from 'src/app/services/inventario.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reportescontabilidad',
  templateUrl: './reportescontabilidad.component.html',
  styleUrls: ['./reportescontabilidad.component.css']
})
export class ReportescontabilidadComponent implements OnInit {

  fechaInicio!: string;
  fechaFin!: string;

  reporte: any[] = [];
  columnas: string[] = [];

  totalGeneral: number = 0;
  totalesColumnas: any = {};

  constructor(private inventarioService: InventarioService) {}

  ngOnInit(): void {}

  calcularTotal() {

  this.totalGeneral = 0;

  this.totalesColumnas = {
    exento: 0,
    tasa0: 0,
    tasa16: 0,
    iva: 0,
    isr: 0,
    ajuste: 0,
    total: 0
  };

  this.reporte.forEach(item => {

    this.totalesColumnas.exento += Number(item.exento || 0);
    this.totalesColumnas.tasa0 += Number(item.tasa0 || 0);
    this.totalesColumnas.tasa16 += Number(item.tasa16 || 0);
    this.totalesColumnas.iva += Number(item.iva || 0);
    this.totalesColumnas.isr += Number(item.isr || 0);
    this.totalesColumnas.ajuste += Number(item.ajuste || 0);
    this.totalesColumnas.total += Number(item.total || 0);

  });

  this.totalGeneral = this.totalesColumnas.total;
}

 consultarPolizas() {
  if (!this.fechaInicio || !this.fechaFin) {
    Swal.fire({
      icon: 'warning',
      title: 'Selecciona un rango de fechas',
      confirmButtonText: 'Aceptar'
    });
    return;
  }

  this.inventarioService.reportePolizasConFacturas({
    fechaInicio: this.fechaInicio,
    fechaFin: this.fechaFin
  }).subscribe({
    next: (res) => {

      if (!res || res.length === 0) {
        this.reporte = [];
        this.columnas = [];

        Swal.fire({
          icon: 'info',
          title: 'Sin resultados',
          text: 'No hay pólizas en las fechas seleccionadas',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      this.reporte = res;
this.columnas = Object.keys(res[0]).filter(
col => col !== 'proveedor' && col !== 'factura'
);      this.calcularTotal();
    },
    error: () => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al consultar reporte de pólizas'
      });
    }
  });
}

 consultarFacturasProveedor() {
  if (!this.fechaInicio || !this.fechaFin) {
    Swal.fire({
      icon: 'warning',
      title: 'Selecciona un rango de fechas',
      confirmButtonText: 'Aceptar'
    });
    return;
  }

  this.inventarioService.reporteFacturasProveedor({
    fechaInicio: this.fechaInicio,
    fechaFin: this.fechaFin
  }).subscribe({
    next: (res) => {

      if (!res || res.length === 0) {
        this.reporte = [];
        this.columnas = [];

        Swal.fire({
          icon: 'info',
          title: 'Sin resultados',
          text: 'No hay datos de proveedores en las fechas seleccionadas',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      this.reporte = res;
this.columnas = Object.keys(res[0]).filter(
col => col !== 'proveedor' && col !== 'factura'
);      this.calcularTotal();
    },
    error: () => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al consultar reporte de proveedores'
      });
    }
  });
}

  exportarExcel() {
    if (this.reporte.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No hay datos para exportar'
      });
      return;
    }

    const dataExport = [...this.reporte];

    const filaTotal: any = {};

    this.columnas.forEach(col => {

      if (col === this.columnas[0]) {
        filaTotal[col] = 'TOTAL';
      }
    else if (this.totalesColumnas[col] !== undefined) {
  filaTotal[col] = this.totalesColumnas[col];
}
else {
  filaTotal[col] = '';
}

    });

    dataExport.push(filaTotal);

    const ws = XLSX.utils.json_to_sheet(dataExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Reporte');
    const hoy = new Date();

    const fechaArchivo =
     hoy.getFullYear() +
    '-' +
    String(hoy.getMonth() + 1).padStart(2,'0') +
    '-' +
    String(hoy.getDate()).padStart(2,'0');

   XLSX.writeFile(
    wb,
    `reporte_${fechaArchivo}.xlsx`
);  }

  exportarTXT() {
    if (this.reporte.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No hay datos para exportar'
      });
      return;
    }

    let contenido = '';

    contenido += this.columnas.join('\t') + '\n';

    this.reporte.forEach(row => {
      const fila = this.columnas.map(col => row[col]);
      contenido += fila.join('\t') + '\n';
    });

    const filaTotal = this.columnas.map(col => {

      if (col === this.columnas[0]) return 'TOTAL';

    if (this.totalesColumnas[col] !== undefined) {
  return this.totalesColumnas[col];
}

      return '';

    });

    contenido += filaTotal.join('\t');

    const blob = new Blob([contenido], { type: 'text/plain;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
const hoy = new Date();

const fechaArchivo =
  hoy.getFullYear() +
  '-' +
  String(hoy.getMonth() + 1).padStart(2,'0') +
  '-' +
  String(hoy.getDate()).padStart(2,'0');

link.download = `reporte_${fechaArchivo}.txt`;    link.click();
  }
}